// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty--1H5fB","plusCard":"plusCard--282fM"};